import axios from 'axios'
import dayjs from 'dayjs'

export const NOT_CALCULATED_LABEL = 'טרם חושב'
export const DISABLED_LABEL = 'כבויה'

/** The card's end-unit box: the number, or the not-calculated label, and the time of the last count. */
export function candidateCountView(
  kpi: number,
  computedAt?: string | null,
  enabled = true
) {
  if (!enabled) {
    return { pending: true as const, value: DISABLED_LABEL, caption: '' }
  }
  if (computedAt === null) {
    return { pending: true as const, value: NOT_CALCULATED_LABEL, caption: '' }
  }
  return {
    pending: false as const,
    value: String(kpi),
    caption: computedAt
      ? `חושב ${dayjs(computedAt).format('DD/MM HH:mm')}`
      : '',
  }
}

export type RefreshOutcome = {
  kind: 'done' | 'wait' | 'unavailable' | 'failed'
  message: string
}

function waitText(seconds: number) {
  if (seconds < 60) return `${seconds} שניות`
  const minutes = Math.ceil(seconds / 60)
  return minutes === 1 ? 'דקה' : `${minutes} דקות`
}

export const REFRESH_DONE: RefreshOutcome = {
  kind: 'done',
  message: 'הספירה עודכנה',
}

/** What the page tells the user when the refresh request failed. A 429 carries the seconds to wait. */
export function refreshFailure(error: unknown): RefreshOutcome {
  if (!axios.isAxiosError(error))
    return { kind: 'failed', message: 'רענון הספירה נכשל' }
  if (error.response?.status === 429) {
    const seconds: number = error.response.data?.data?.retryAfterSeconds ?? 60
    return {
      kind: 'wait',
      message: `הספירה עודכנה לפני רגע. אפשר לרענן שוב בעוד ${waitText(seconds)}`,
    }
  }
  if (error.response?.status === 422) {
    return { kind: 'failed', message: 'לא ניתן לחשב, בעיית הגדרות' }
  }
  if (error.response?.status === 501) {
    return {
      kind: 'unavailable',
      message: 'רענון הספירה אינו זמין במסד הנתונים הזה',
    }
  }
  return { kind: 'failed', message: 'רענון הספירה נכשל' }
}
